export default "__VITE_ASSET__d6c7c020__"